// src/features/wf2/popup/W2Salvar.jsx
// Helper central para chamar SALVAR (rascunho) ou EDITAR (edição WF-2)

import { salvarW2, editarW2 } from "../api";

/**
 * Helper genérico para WF-2:
 *
 * mode:
 *  - "salvar" → força chamar /wf_2/salvar (rascunho: preenche apenas campos vazios)
 *  - "editar" → força chamar /wf_2/editar  (edição com histórico/justificativa)
 *
 * Obs: não usamos mais a heurística por id; quem chama decide o modo
 * de acordo com as regras de negócio (ex.: primeira gravação vs edição).
 */
export async function salvarOuEditarW2FromPayload(
  payload = {},
  mode = "salvar"
) {
  if (mode === "editar") {
    // edição de WF-2 existente
    return editarW2(payload);
  }

  // padrão: rascunho SALVAR
  return salvarW2(payload);
}
